import { Workbox } from 'workbox-window'

export default { register }

export function register(scriptURL: string) {
  if (!navigator.serviceWorker) {
    console.error('Whoops. Service worker registration failed, navigator.serviceWorker is undefined')
    return
  }

  const wb = new Workbox(scriptURL)
  wb.register().then((registration: ServiceWorkerRegistration) => {
    console.info('Hooray. Registration successful, scope is:', registration.scope)
  }).catch((err: {}) => {
    console.error('Whoops. Service worker registration failed, error:', err)
  })
}
